import { TranslationDictionary } from '@domgen/dgx-fe-i18n';
import { FeatureApplianceDetailsTranslationKeys } from './feature-appliance-details-translation-keys.type';

export type FeatureApplianceDetailsTranslationDictionary =
  TranslationDictionary<FeatureApplianceDetailsTranslationKeys>;
